import React, { useEffect, useRef, useState } from "react";
import CanvasDraw from "react-canvas-draw";
import { useSelector } from "react-redux";
import KeyboardEventHandler from "react-keyboard-event-handler";
import { socketActions } from "../../imports";

const DrawOnScreen = React.forwardRef((props, ref) => {
	// const [hideInterface, setHideInterface] = useState(true);
	const [remove, setRemove] = useState(false);
	const holderRef = useRef(null);
	const canvasRef = useRef(null);
	
	const drawingEnabled =
	useSelector((state) => state.main?.settings?.output_draw_on_screen) ||
	"false";
	
	const drawingColour =
	useSelector(
		(state) => state.main?.settings?.output_draw_on_screen_colour
	) || "#333333";
	
	const brushSize =
	useSelector((state) => state.main?.settings?.output_draw_on_screen_size) ||
	6;

	const handleSaveDrawing = () => {
		const currentDrawing = canvasRef.current?.getSaveData()
		socketActions.updateSettings({
			output_draw_current_save: currentDrawing,
		});
	}

	function resize() {
		setRemove(true);

		setTimeout(() => {
			setRemove(false);
		}, 1000);
	}

	useEffect(() => {
		window.addEventListener("resize", resize);
	}, []);

	return (
		<div
			ref={holderRef}
			// onMouseEnter={() => {
			// 	setHideInterface(false);
			// }}
			// onMouseLeave={() => {
			// 	return handleShouldLeave();
			// }}
			className={`relative 
			${
				drawingEnabled === "true"
					? "opacity-100 pointer-events-auto"
					: "opacity-0 pointer-events-none"
			}
			`}
			onDoubleClick={()=>{
				return canvasRef.current.clear();
			}}
		>
			<KeyboardEventHandler
				handleKeys={["c"]}
				onKeyEvent={(key, e) => {
					e.preventDefault();
					handleSaveDrawing()
					return canvasRef.current.clear();
				}}
			/>
			<KeyboardEventHandler
				handleKeys={["u"]}
				onKeyEvent={(key, e) => {
					e.preventDefault();
					return canvasRef.current.undo();
				}}
			/>
			<CanvasDraw
				ref={canvasRef}
				style={{
					touchAction: "manipulation !important",
				}}
				className={`fixed z-50 w-screen h-screen`}
				canvasWidth={ref.current?.clientWidth}
				canvasHeight={ref.current?.clientHeight}
				hideGrid={true}
				backgroundColor={`transparent`}
				brushColor={drawingColour}
				hideInterface={true}
				brushRadius={parseInt(brushSize)}
				lazyRadius={3}
			/>
		</div>
	);
});

export default DrawOnScreen;
